<template>
  <a-select
    :showSearch="true"
    :value="!!oValue ? oValue : undefined"
    :filterOption="false"
    option-label-prop="label"
    placeholder="请选择绑定的烯牛项目"
    @search="handleSearch"
    @change="handleChange"
  >
    <a-select-option v-for="item in options" :key="item.id" :label="item.fullName">
      <div class="option-item">
        <a-avatar size="small" :src="item.logo" class="img"></a-avatar>
        <div>
          <div>{{ item.name }}({{ item.fullName }})</div>
          <div>{{ item.industry }}, {{ item.brief }}</div>
        </div>
      </div>
    </a-select-option>
  </a-select>
</template>
<script>
import { searchThirdCompany } from '@/api/project.js';
export default {
  props: {
    value: {
      type: [Number, String],
      default: undefined
    }
  },
  data() {
    return {
      oValue: null,
      options: []
    };
  },
  watch: {
    value(v) {
      if (v !== this.oValue) {
        this.oValue = v;
      }
    }
  },
  methods: {
    handleSearch(keyword) {
      searchThirdCompany(keyword).then(res => {
        this.options = res.data;
      });
    },
    handleChange(value) {
      this.oValue = value;
      let item = this.options.find(i => i.id === value);
      this.$emit('change', item);
    }
  }
};
</script>
<style lang="less" scoped>
.option-item {
  display: flex;
  align-items: center;
  .img {
    margin-right: 10px;
  }
}
</style>
